module.exports = __webpack_public_path__ + "static/in-peace-7a266e130a8c67ae4342cced040298b1.jpg";